import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from './Navbar';
import Footer from './Footer';
import NemwelExperiences from './AboutMeRoutes/Experience';

function ResumePage() {
  const handlePrint = () => window.print();

  return (
    <div className="ResumePage">
      <Helmet>
        <title>Resume — Nemwel Boniface</title>
        <meta name="description" content="Professional experience, skills, and achievements of Nemwel Boniface. Download or print the resume." />
        <link rel="canonical" href="https://nemwelboniface.netlify.app/resume" />
      </Helmet>
      <Navbar />
      <header className="resume-header">
        <div className="resume-title">
          <h1>Resume</h1>
          <p>Professional experience, skills, and achievements</p>
        </div>
        <div className="resume-actions">
          <button className="btn" type="button" onClick={handlePrint}>Print</button>
        </div>
      </header>

      <main className="resume-content">
        <NemwelExperiences />
      </main>

      <Footer />
    </div>
  );
}

export default ResumePage;
